module.exports = __webpack_public_path__ + "static/img/race2.46838da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/race2.png
// module id = qz0S
// module chunks = 1 3